import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation updateMarker($id: ID!, $model: UpdateMarkerInput !) {
  updateMarker(id: $id, input: $model) {
    id
    name
    description
    directory {
      id
    }
    answerTemplates {
      id
      text
      value
    }
  }
}`;

function updateMarker(id, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model,
    },
  }).then((res) => res.data.updateMarker);
}

export default updateMarker;
